import React from 'react';
import Switch from '@rio-cloud/rio-uikit/Switch';
import { FormattedMessage } from 'react-intl';

interface DecoupledUpdateFormItemProps {
    value: boolean;
    onChange: (value: boolean) => void;
}

const DecoupledUpdateFormItem: React.FC<DecoupledUpdateFormItemProps> = ({ value, onChange }) => {
    return (
        <div className={'margin-bottom-10 margin-top-10'}>
            <div>
                <label><FormattedMessage id={'intl-msg:decoupledUpdate.badge'}/></label>
            </div>
            <Switch onChange={() => onChange(!value)} checked={value || false}/>
        </div>
    );
};

export default DecoupledUpdateFormItem;
